import * as Yup from "yup";

const enderecoValidator = Yup.object().shape({
  exterior: Yup.boolean().nullable().required(),
  cep: Yup.string().when("exterior", {
    is: false,
    then: Yup.string()
      .matches(/^[0-9]{8}$/, "CEP inválido")
      .nullable()
      .required("CEP"),
    otherwise: Yup.string().nullable(),
  }),
  logradouro: Yup.string().nullable().required("Logradouro"),
  numero: Yup.string().nullable().required("Número"),
  bairro: Yup.string().nullable().required("Bairro"),
  cidadeId: Yup.number().when("exterior", {
    is: false,
    then: Yup.number().nullable().required("Cidade"),
    otherwise: Yup.number().nullable(),
  }),
  paisId: Yup.number().when("exterior", {
    is: true,
    then: Yup.number().nullable().required("País"),
    otherwise: Yup.number().nullable(),
  }),
  descricao: Yup.string().nullable(),
  inscricaoEstadual: Yup.string().nullable(),
});

export default enderecoValidator;
